import { legacy_connect as connect } from 'react-redux';

import { AppState } from '../../../store/reducers/root';
import {
  getNotifications,
  getNotificationsCount,
} from '../../../store/selectors/notifications';
import notificationsAction from '../../../store/slices/notifications';

import Notifications from './Notifications';

const mapStateToProps = (state: AppState) => ({
  unread: getNotificationsCount(state),
  notifications: getNotifications(state),
});

export default connect(mapStateToProps, {
  onNotificationClick: notificationsAction.click,
})(Notifications);
